import React from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import Carousel from "../../Carousel";
import { contentContainer } from "../../ContentContainer";
import Markdown from "../../Markdown";
import SmallShapeContainer from "../../SmallShapeContainer";
import ShapeImg from "./ShapeImg";

const Container = styled.div`
    ${contentContainer}
    ${({ theme }) => theme.breakpoints.upTo.small.css`
        padding: 0 30px;
    `}
+
    ${({ theme }) => theme.breakpoints.upTo.extraSmall.css`
        padding: 0 20px;
    `}
`;

const BackgroundContainer = styled(SmallShapeContainer.ImageContainer)`
    background-color: ${({ theme }) => theme.colors.red.toString()};
`;

const Item = styled(Carousel.Item)`
    width: 260px;
`;

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 2.5rem;
    font-weight: 900;
    color: ${({ theme }) => theme.colors.white.toString()};
    font-family: var(--font-family-vito);
    padding-top: 17px;
    padding-bottom: 10px;
    gap: 1rem;
`;

const Number = styled.div`
    font-size: 5rem;
    line-height: 4rem;
`;

const Rotation = styled.div`
    line-height: 2rem;
`;

const Headline = styled.div`
    font-size: 1rem;
    font-weight: 900;
`;

const Text = styled(Markdown)`
    margin: 10px 0;
    ul {
        margin: 0 0 0 20px;
    }
`;

const HeadlineContainer = styled.div`
    background-color: ${({ theme }) => theme.colors.red.toString()};
    width: 100vw;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        width: 65vw;
    `}
    padding: 50px 0;
    position: relative;
    margin-bottom: 50px;
`;

const HeadlineWrapper = styled(Markdown)`
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}
    font-size: 2.5rem;
    font-weight: 900;
    color: ${({ theme }) => theme.colors.white.toString()};
    ${({ theme }) => theme.breakpoints.from.medium.css`
        padding-right: 140px;
        font-size: 3.5rem;
    `}
`;

const ShpaeContainer = styled.div`
    display: none;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        display: block;
    `}
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    transform: scaleX(-1);
    svg {
        height: 100%;
        width: auto;
    }
`;

const StudyRotation = ({ name, rotationItems }) => {
    return (
        <>
            <HeadlineContainer>
                <HeadlineWrapper>{name}</HeadlineWrapper>
                <ShpaeContainer>
                    <ShapeImg />
                </ShpaeContainer>
            </HeadlineContainer>
            <Container>
                <Carousel>
                    {rotationItems.map((item, i) => (
                        <Item key={i}>
                            <SmallShapeContainer>
                                <BackgroundContainer>
                                    <HeaderContainer>
                                        <Rotation>Rotation</Rotation>
                                        <Number> {parseInt(i) + 1}</Number>
                                    </HeaderContainer>
                                </BackgroundContainer>
                                <SmallShapeContainer.TextContainer>
                                    <div
                                        css={css`
                                            min-height: 120px;
                                        `}
                                    >
                                        <Headline>{item.name}</Headline>
                                        <Text>{item.text}</Text>
                                    </div>
                                </SmallShapeContainer.TextContainer>
                            </SmallShapeContainer>
                        </Item>
                    ))}
                </Carousel>
            </Container>
        </>
    );
};

export default StudyRotation;
